export const countries = [
    { code: "US", label: "United States of America" },
    { code: "CA", label: "Canada" },
    { code: "MX", label: "Mexico" },
    { code: "OTHER", label: "Other Countries" },
    { code: "US_TERRITORIES", label: "US Territories" }
]

export const mxStates = [
  {code: "MX", label: "Mexico"},
  {code: "AG", label: "Aguascalientes"},
  {code: "BA", label: "Baja California"},  
  {code: "BJ", label: "Baja California Sur"},  
  {code: "CE", label: "Campeche"},  
  {code: "CI", label: "Chiapas"},  
  {code: "CH", label: "Chihuahua"},  
  {code: "CU", label: "Coahuila de Zaragoza"},  
  {code: "CL", label: "Colima"}, 
  {code: "DF", label: "Distrito Federal Mexico"},
  {code: "DO", label: "Durango"}, 
  {code: "EM", label: "Estado de Mexico"},  
  {code: "GR", label: "Guerrero"},   
  {code: "GU", label: "Guanajuato"},
  {code: "HL", label: "Hidalgo"},  
  {code: "JL", label: "Jalisco"},   
  {code: "MC", label: "Michoacan de Ocampo"},  
  {code: "MR", label: "Morelos"},  
  {code: "NA", label: "Nayarit"},  
  {code: "NL", label: "Nuevo Leon"},  
  {code: "OA", label: "Oaxaca"},  
  {code: "PB", label: "Puebla"},  
  {code: "QU", label: "Queretaro de Arteaga"},  
  {code: "QR", label: "Quintana Roo"},  
  {code: "SL", label: "San Luis Potosi"},  
  {code: "SI", label: "Sinaloa"},
  {code: "SO", label: "Sonora"},  
  {code: "TB", label: "Tabasco"},  
  {code: "TA", label: "Tamaulipas"},  
  {code: "TL", label: "Tlaxcala"},  
  {code: "VC", label: "Veracruz-Llave"},  
  {code: "YU", label: "Yucatan"}, 
  {code: "ZA", label: "Zacatecas"}
]
export const countryOptions = {
  "MX": [
    {
      "code": "MX",
      "label": "Mexico"
    }
  ],
  "CA": [
    {
      "code": "AB",
      "label": "Alberta"
    },
    {
      "code": "BC",
      "label": "British Columbia"
    },
    {
      "code": "MB",
      "label": "Manitoba"
    },
    {
      "code": "NB",
      "label": "New Brunswick"
    },
    {
      "code": "NF",
      "label": "Newfoundland and Labrador"
    },
    {
      "code": "NS",
      "label": "Nova Scotia"
    },
    {
      "code": "NT",
      "label": "Northwest Territories"
    },
    {
      "code": "NU",
      "label": "Nunavut"
    },
    {
      "code": "ON",
      "label": "Ontario"
    },
    {
      "code": "PE",
      "label": "Prince Edward Island"
    },
    {
      "code": "QC",
      "label": "Quebec"
    },
    {
      "code": "SK",
      "label": "Saskatchewan"
    },
    {
      "code": "YT",
      "label": "Yukon"
    }
  ],
  "US": [
    // {
    //   "code": "Z6",
    //   "label": "(Z6)TESTING"
    // },
    // {
    //   "code": "P6",
    //   "label": "(P6)TESTING"
    // },
    // {
    //   "code": "P3",
    //   "label": "(P3)TESTING"
    // },
    {
      "code": "AL",
      "label": "Alabama"
    },
    {
      "code": "AK",
      "label": "Alaska"
    },
    {
      "code": "AZ",
      "label": "Arizona"
    },
    {
      "code": "AR",
      "label": "Arkansas"
    },
    {
      "code": "CA",
      "label": "California"
    },
    {
      "code": "CO",
      "label": "Colorado"
    },
    {
      "code": "CT",
      "label": "Connecticut"
    },
    {
      "code": "DE",
      "label": "Delaware"
    },
    {
      "code": "DC",
      "label": "District of Columbia"
    },
    {
      "code": "FL",
      "label": "Florida"
    },
    {
      "code": "GA",
      "label": "Georgia"
    },
    {
      "code": "HI",
      "label": "Hawaii"
    },
    {
      "code": "ID",
      "label": "Idaho"
    },
    {
      "code": "IL",
      "label": "Illinois"
    },
    {
      "code": "IN",
      "label": "Indiana"
    },
    {
      "code": "IA",
      "label": "Iowa"
    },
    {
      "code": "KS",
      "label": "Kansas"
    },
    {
      "code": "KY",
      "label": "Kentucky"
    },
    {
      "code": "LA",
      "label": "Louisiana"
    },
    {
      "code": "ME",
      "label": "Maine"
    },
    {
      "code": "MD",
      "label": "Maryland"
    },
    {
      "code": "MA",
      "label": "Massachusetts"
    },
    {
      "code": "MI",
      "label": "Michigan"
    },
    {
      "code": "MN",
      "label": "Minnesota"
    },
    {
      "code": "MS",
      "label": "Mississippi"
    },
    {
      "code": "MO",
      "label": "Missouri"
    },
    {
      "code": "MT",
      "label": "Montana"
    },
    {
      "code": "NE",
      "label": "Nebraska"
    },
    {
      "code": "NV",
      "label": "Nevada"
    },
    {
      "code": "NH",
      "label": "New Hampshire"
    },
    {
      "code": "NJ",
      "label": "New Jersey"
    },
    {
      "code": "NM",
      "label": "New Mexico"
    },
    {
      "code": "NY",
      "label": "New York"
    },
    {
      "code": "NC",
      "label": "North Carolina"
    },
    {
      "code": "ND",
      "label": "North Dakota"
    },
    {
      "code": "OH",
      "label": "Ohio"
    },
    {
      "code": "OK",
      "label": "Oklahoma"
    },
    {
      "code": "OR",
      "label": "Oregon"
    },
    {
      "code": "PA",
      "label": "Pennsylvania"
    },
    {
      "code": "RI",
      "label": "Rhode Island"
    },
    {
      "code": "SC",
      "label": "South Carolina"
    },
    {
      "code": "SD",
      "label": "South Dakota"
    },
    {
      "code": "TN",
      "label": "Tennessee"
    },
    {
      "code": "TX",
      "label": "Texas"
    },
    {
      "code": "UT",
      "label": "Utah"
    },
    {
      "code": "VT",
      "label": "Vermont"
    },
    {
      "code": "VA",
      "label": "Virginia"
    },
    {
      "code": "WA",
      "label": "Washington"
    },
    {
      "code": "WV",
      "label": "West Virginia"
    },
    {
      "code": "WI",
      "label": "Wisconsin"
    },
    {
      "code": "WY",
      "label": "Wyoming"
    }
  ],
  "US_TERRITORIES": [
    {
      "code": "AS",
      "label": "American Samoa"
    },
    {
      "code": "FM",
      "label": "Federated States of Micronesia"
    },
    {
      "code": "GM",
      "label": "Guam"
    },
    {
      "code": "MH",
      "label": "Marshall Islands"
    },
    {
      "code": "MP",
      "label": "Northern Mariana Islands"
    },
    {
      "code": "PR",
      "label": "Puerto Rico"
    },
    {
      "code": "PW",
      "label": "Palau"
    },
    {
      "code": "PZ",
      "label": "Panamanian Canal Zone"
    },
    // {
    //   "code": "UMI",
    //   "label": "Minor Outlying Islands"
    // },
    {
      "code": "VI",
      "label": "Virgin Islands"
    },
    {
      "code": "WK",
      "label": "Wake Island"
    }
  ],
  "OTHER": [
    {
      "code": "ABW",
      "label": "Aruba"
    },
    {
      "code": "AFG",
      "label": "Afghanistan"
    },
    {
      "code": "AGO",
      "label": "Angola"
    },
    {
      "code": "AIA",
      "label": "Anguilla"
    },
    {
      "code": "ALA",
      "label": "\u00c5land Islands"
    },
    {
      "code": "ALB",
      "label": "Albania"
    },
    {
      "code": "AND",
      "label": "Andorra"
    },
    {
      "code": "ARE",
      "label": "United Arab Emirates"
    },
    {
      "code": "ARG",
      "label": "Argentina"
    },
    {
      "code": "ARM",
      "label": "Armenia"
    },
    {
      "code": "ATA",
      "label": "Antarctica"
    },
    {
      "code": "ATF",
      "label": "French Southern Territories"
    },
    {
      "code": "ATG",
      "label": "Antigua and Barbuda"
    },
    {
      "code": "AUS",
      "label": "Australia"
    },
    {
      "code": "AUT",
      "label": "Austria"
    },
    {
      "code": "AZE",
      "label": "Azerbaijan"
    },
    {
      "code": "BDI",
      "label": "Burundi"
    },
    {
      "code": "BEL",
      "label": "Belgium"
    },
    {
      "code": "BEN",
      "label": "Benin"
    },
    {
      "code": "BES",
      "label": "Bonaire, Sint Eustatius and Saba"
    },
    {
      "code": "BFA",
      "label": "Burkina Faso"
    },
    {
      "code": "BGD",
      "label": "Bangladesh"
    },
    {
      "code": "BGR",
      "label": "Bulgaria"
    },
    {
      "code": "BHR",
      "label": "Bahrain"
    },
    {
      "code": "BHS",
      "label": "Bahamas"
    },
    {
      "code": "BIH",
      "label": "Bosnia and Herzegovina"
    },
    {
      "code": "BLM",
      "label": "Saint Barth\u00e9lemy"
    },
    {
      "code": "BLR",
      "label": "Belarus"
    },
    {
      "code": "BLZ",
      "label": "Belize"
    },
    {
      "code": "BMU",
      "label": "Bermuda"
    },
    {
      "code": "BOL",
      "label": "Bolivia, Plurinational State of"
    },
    {
      "code": "BRA",
      "label": "Brazil"
    },
    {
      "code": "BRB",
      "label": "Barbados"
    },
    {
      "code": "BRN",
      "label": "Brunei Darussalam"
    },
    {
      "code": "BTN",
      "label": "Bhutan"
    },
    {
      "code": "BVT",
      "label": "Bouvet Island"
    },
    {
      "code": "BWA",
      "label": "Botswana"
    },
    {
      "code": "CAF",
      "label": "Central African Republic"
    },
    {
      "code": "CAN",
      "label": "Canada"
    },
    {
      "code": "CCK",
      "label": "Cocos (Keeling) Islands"
    },
    {
      "code": "CHE",
      "label": "Switzerland"
    },
    {
      "code": "CHL",
      "label": "Chile"
    },
    {
      "code": "CHN",
      "label": "China"
    },
    {
      "code": "CIV",
      "label": "C\u00f4te d'Ivoire"
    },
    {
      "code": "CMR",
      "label": "Cameroon"
    },
    {
      "code": "COD",
      "label": "Congo, The Democratic Republic of the"
    },
    {
      "code": "COG",
      "label": "Congo"
    },
    {
      "code": "COK",
      "label": "Cook Islands"
    },
    {
      "code": "COL",
      "label": "Colombia"
    },
    {
      "code": "COM",
      "label": "Comoros"
    },
    {
      "code": "CPV",
      "label": "Cabo Verde"
    },
    {
      "code": "CRI",
      "label": "Costa Rica"
    },
    {
      "code": "CUB",
      "label": "Cuba"
    },
    {
      "code": "CUW",
      "label": "Cura\u00e7ao"
    },
    {
      "code": "CXR",
      "label": "Christmas Island"
    },
    {
      "code": "CYM",
      "label": "Cayman Islands"
    },
    {
      "code": "CYP",
      "label": "Cyprus"
    },
    {
      "code": "CZE",
      "label": "Czechia"
    },
    {
      "code": "DEU",
      "label": "Germany"
    },
    {
      "code": "DJI",
      "label": "Djibouti"
    },
    {
      "code": "DMA",
      "label": "Dominica"
    },
    {
      "code": "DNK",
      "label": "Denmark"
    },
    {
      "code": "DOM",
      "label": "Dominican Republic"
    },
    {
      "code": "DZA",
      "label": "Algeria"
    },
    {
      "code": "ECU",
      "label": "Ecuador"
    },
    {
      "code": "EGY",
      "label": "Egypt"
    },
    {
      "code": "ERI",
      "label": "Eritrea"
    },
    {
      "code": "ESH",
      "label": "Western Sahara"
    },
    {
      "code": "ESP",
      "label": "Spain"
    },
    {
      "code": "EST",
      "label": "Estonia"
    },
    {
      "code": "ETH",
      "label": "Ethiopia"
    },
    {
      "code": "FIN",
      "label": "Finland"
    },
    {
      "code": "FJI",
      "label": "Fiji"
    },
    {
      "code": "FLK",
      "label": "Falkland Islands (Malvinas)"
    },
    {
      "code": "FRA",
      "label": "France"
    },
    {
      "code": "FRO",
      "label": "Faroe Islands"
    },
    {
      "code": "FSM",
      "label": "Micronesia, Federated States of"
    },
    {
      "code": "GAB",
      "label": "Gabon"
    },
    {
      "code": "GBR",
      "label": "United Kingdom"
    },
    {
      "code": "GEO",
      "label": "Georgia"
    },
    {
      "code": "GGY",
      "label": "Guernsey"
    },
    {
      "code": "GHA",
      "label": "Ghana"
    },
    {
      "code": "GIB",
      "label": "Gibraltar"
    },
    {
      "code": "GIN",
      "label": "Guinea"
    },
    {
      "code": "GLP",
      "label": "Guadeloupe"
    },
    {
      "code": "GMB",
      "label": "Gambia"
    },
    {
      "code": "GNB",
      "label": "Guinea-Bissau"
    },
    {
      "code": "GNQ",
      "label": "Equatorial Guinea"
    },
    {
      "code": "GRC",
      "label": "Greece"
    },
    {
      "code": "GRD",
      "label": "Grenada"
    },
    {
      "code": "GRL",
      "label": "Greenland"
    },
    {
      "code": "GTM",
      "label": "Guatemala"
    },
    {
      "code": "GUF",
      "label": "French Guiana"
    },
    {
      "code": "GUY",
      "label": "Guyana"
    },
    {
      "code": "HKG",
      "label": "Hong Kong"
    },
    {
      "code": "HMD",
      "label": "Heard Island and McDonald Islands"
    },
    {
      "code": "HND",
      "label": "Honduras"
    },
    {
      "code": "HRV",
      "label": "Croatia"
    },
    {
      "code": "HTI",
      "label": "Haiti"
    },
    {
      "code": "HUN",
      "label": "Hungary"
    },
    {
      "code": "IDN",
      "label": "Indonesia"
    },
    {
      "code": "IMN",
      "label": "Isle of Man"
    },
    {
      "code": "IND",
      "label": "India"
    },
    {
      "code": "IOT",
      "label": "British Indian Ocean Territory"
    },
    {
      "code": "IRL",
      "label": "Ireland"
    },
    {
      "code": "IRN",
      "label": "Iran, Islamic Republic of"
    },
    {
      "code": "IRQ",
      "label": "Iraq"
    },
    {
      "code": "ISL",
      "label": "Iceland"
    },
    {
      "code": "ISR",
      "label": "Israel"
    },
    {
      "code": "ITA",
      "label": "Italy"
    },
    {
      "code": "JAM",
      "label": "Jamaica"
    },
    {
      "code": "JEY",
      "label": "Jersey"
    },
    {
      "code": "JOR",
      "label": "Jordan"
    },
    {
      "code": "JPN",
      "label": "Japan"
    },
    {
      "code": "KAZ",
      "label": "Kazakhstan"
    },
    {
      "code": "KEN",
      "label": "Kenya"
    },
    {
      "code": "KGZ",
      "label": "Kyrgyzstan"
    },
    {
      "code": "KHM",
      "label": "Cambodia"
    },
    {
      "code": "KIR",
      "label": "Kiribati"
    },
    {
      "code": "KNA",
      "label": "Saint Kitts and Nevis"
    },
    {
      "code": "KOR",
      "label": "Korea, Republic of"
    },
    {
      "code": "KWT",
      "label": "Kuwait"
    },
    {
      "code": "LAO",
      "label": "Lao People's Democratic Republic"
    },
    {
      "code": "LBN",
      "label": "Lebanon"
    },
    {
      "code": "LBR",
      "label": "Liberia"
    },
    {
      "code": "LBY",
      "label": "Libya"
    },
    {
      "code": "LCA",
      "label": "Saint Lucia"
    },
    {
      "code": "LIE",
      "label": "Liechtenstein"
    },
    {
      "code": "LKA",
      "label": "Sri Lanka"
    },
    {
      "code": "LSO",
      "label": "Lesotho"
    },
    {
      "code": "LTU",
      "label": "Lithuania"
    },
    {
      "code": "LUX",
      "label": "Luxembourg"
    },
    {
      "code": "LVA",
      "label": "Latvia"
    },
    {
      "code": "MAC",
      "label": "Macao"
    },
    {
      "code": "MAF",
      "label": "Saint Martin (French part)"
    },
    {
      "code": "MAR",
      "label": "Morocco"
    },
    {
      "code": "MCO",
      "label": "Monaco"
    },
    {
      "code": "MDA",
      "label": "Moldova, Republic of"
    },
    {
      "code": "MDG",
      "label": "Madagascar"
    },
    {
      "code": "MDV",
      "label": "Maldives"
    },
    {
      "code": "MHL",
      "label": "Marshall Islands"
    },
    {
      "code": "MKD",
      "label": "North Macedonia"
    },
    {
      "code": "MLI",
      "label": "Mali"
    },
    {
      "code": "MLT",
      "label": "Malta"
    },
    {
      "code": "MMR",
      "label": "Myanmar"
    },
    {
      "code": "MNE",
      "label": "Montenegro"
    },
    {
      "code": "MNG",
      "label": "Mongolia"
    },
    {
      "code": "MOZ",
      "label": "Mozambique"
    },
    {
      "code": "MRT",
      "label": "Mauritania"
    },
    {
      "code": "MSR",
      "label": "Montserrat"
    },
    {
      "code": "MTQ",
      "label": "Martinique"
    },
    {
      "code": "MUS",
      "label": "Mauritius"
    },
    {
      "code": "MWI",
      "label": "Malawi"
    },
    {
      "code": "MYS",
      "label": "Malaysia"
    },
    {
      "code": "MYT",
      "label": "Mayotte"
    },
    {
      "code": "NAM",
      "label": "Namibia"
    },
    {
      "code": "NCL",
      "label": "New Caledonia"
    },
    {
      "code": "NER",
      "label": "Niger"
    },
    {
      "code": "NFK",
      "label": "Norfolk Island"
    },
    {
      "code": "NGA",
      "label": "Nigeria"
    },
    {
      "code": "NIC",
      "label": "Nicaragua"
    },
    {
      "code": "NIU",
      "label": "Niue"
    },
    {
      "code": "NLD",
      "label": "Netherlands"
    },
    {
      "code": "NOR",
      "label": "Norway"
    },
    {
      "code": "NPL",
      "label": "Nepal"
    },
    {
      "code": "NRU",
      "label": "Nauru"
    },
    {
      "code": "NZL",
      "label": "New Zealand"
    },
    {
      "code": "OMN",
      "label": "Oman"
    },
    {
      "code": "PAK",
      "label": "Pakistan"
    },
    {
      "code": "PAN",
      "label": "Panama"
    },
    {
      "code": "PCN",
      "label": "Pitcairn"
    },
    {
      "code": "PER",
      "label": "Peru"
    },
    {
      "code": "PHL",
      "label": "Philippines"
    },
    {
      "code": "PLW",
      "label": "Palau"
    },
    {
      "code": "PNG",
      "label": "Papua New Guinea"
    },
    {
      "code": "POL",
      "label": "Poland"
    },
    {
      "code": "PRK",
      "label": "Korea, Democratic People's Republic of"
    },
    {
      "code": "PRT",
      "label": "Portugal"
    },
    {
      "code": "PRY",
      "label": "Paraguay"
    },
    {
      "code": "PSE",
      "label": "Palestine, State of"
    },
    {
      "code": "PYF",
      "label": "French Polynesia"
    },
    {
      "code": "QAT",
      "label": "Qatar"
    },
    {
      "code": "REU",
      "label": "R\u00e9union"
    },
    {
      "code": "ROU",
      "label": "Romania"
    },
    {
      "code": "RUS",
      "label": "Russian Federation"
    },
    {
      "code": "RWA",
      "label": "Rwanda"
    },
    {
      "code": "SAU",
      "label": "Saudi Arabia"
    },
    {
      "code": "SDN",
      "label": "Sudan"
    },
    {
      "code": "SEN",
      "label": "Senegal"
    },
    {
      "code": "SGP",
      "label": "Singapore"
    },
    {
      "code": "SGS",
      "label": "South Georgia and the South Sandwich Islands"
    },
    {
      "code": "SHN",
      "label": "Saint Helena, Ascension and Tristan da Cunha"
    },
    {
      "code": "SJM",
      "label": "Svalbard and Jan Mayen"
    },
    {
      "code": "SLB",
      "label": "Solomon Islands"
    },
    {
      "code": "SLE",
      "label": "Sierra Leone"
    },
    {
      "code": "SLV",
      "label": "El Salvador"
    },
    {
      "code": "SMR",
      "label": "San Marino"
    },
    {
      "code": "SOM",
      "label": "Somalia"
    },
    {
      "code": "SPM",
      "label": "Saint Pierre and Miquelon"
    },
    {
      "code": "SRB",
      "label": "Serbia"
    },
    {
      "code": "SSD",
      "label": "South Sudan"
    },
    {
      "code": "STP",
      "label": "Sao Tome and Principe"
    },
    {
      "code": "SUR",
      "label": "Suriname"
    },
    {
      "code": "SVK",
      "label": "Slovakia"
    },
    {
      "code": "SVN",
      "label": "Slovenia"
    },
    {
      "code": "SWE",
      "label": "Sweden"
    },
    {
      "code": "SWZ",
      "label": "Eswatini"
    },
    {
      "code": "SXM",
      "label": "Sint Maarten (Dutch part)"
    },
    {
      "code": "SYC",
      "label": "Seychelles"
    },
    {
      "code": "SYR",
      "label": "Syrian Arab Republic"
    },
    {
      "code": "TCA",
      "label": "Turks and Caicos Islands"
    },
    {
      "code": "TCD",
      "label": "Chad"
    },
    {
      "code": "TGO",
      "label": "Togo"
    },
    {
      "code": "THA",
      "label": "Thailand"
    },
    {
      "code": "TJK",
      "label": "Tajikistan"
    },
    {
      "code": "TKL",
      "label": "Tokelau"
    },
    {
      "code": "TKM",
      "label": "Turkmenistan"
    },
    {
      "code": "TLS",
      "label": "Timor-Leste"
    },
    {
      "code": "TON",
      "label": "Tonga"
    },
    {
      "code": "TTO",
      "label": "Trinidad and Tobago"
    },
    {
      "code": "TUN",
      "label": "Tunisia"
    },
    {
      "code": "TUR",
      "label": "Turkey"
    },
    {
      "code": "TUV",
      "label": "Tuvalu"
    },
    {
      "code": "TWN",
      "label": "Taiwan, Province of China"
    },
    {
      "code": "TZA",
      "label": "Tanzania, United Republic of"
    },
    {
      "code": "UGA",
      "label": "Uganda"
    },
    {
      "code": "UKR",
      "label": "Ukraine"
    },
    {
      "code": "UMI",
      "label": "United States Minor Outlying Islands"
    },
    {
      "code": "URY",
      "label": "Uruguay"
    },
    {
      "code": "USA",
      "label": "United States"
    },
    {
      "code": "UZB",
      "label": "Uzbekistan"
    },
    {
      "code": "VAT",
      "label": "Holy See (Vatican City State)"
    },
    {
      "code": "VCT",
      "label": "Saint Vincent and the Grenadines"
    },
    {
      "code": "VEN",
      "label": "Venezuela, Bolivarian Republic of"
    },
    {
      "code": "VGB",
      "label": "Virgin Islands, British"
    },
    {
      "code": "VNM",
      "label": "Viet Nam"
    },
    {
      "code": "VUT",
      "label": "Vanuatu"
    },
    {
      "code": "WLF",
      "label": "Wallis and Futuna"
    },
    {
      "code": "WSM",
      "label": "Samoa"
    },
    {
      "code": "YEM",
      "label": "Yemen"
    },
    {
      "code": "ZAF",
      "label": "South Africa"
    },
    {
      "code": "ZMB",
      "label": "Zambia"
    },
    {
      "code": "ZWE",
      "label": "Zimbabwe"
    }
  ]
};